import React from 'react'

import { bgColor, borderColor } from '@ui-kit/styles/colors'

import * as styles from './styles'
import type { WebProps } from './types'

const TextFieldContainer = (props: WebProps): JSX.Element => {
  const assistiveTextOrError = props.errorMessage ? props.errorMessage : props.assistiveText
  const hasLabel = props.label !== undefined
  const fieldContainerBorderColor = borderColor({ color: props.borderColor ?? 'uiGreyMedium' })
  const fieldContainerBackgroundColor = bgColor({ color: props.backgroundColor ?? 'uiLight' })
  const { container, fieldContainer, childrenContainer, label, assistiveText } =
    styles.getTextFieldStyles({
      borderColor: fieldContainerBorderColor,
      bgColor: fieldContainerBackgroundColor,
    })({
      disabled: props.disabled,
      isFocused: props.isFocused,
      isFilled: props.isFilled,
      styleType: props.styleType,
      hasLabel,
      status: props.status,
    })

  return (
    <div className={container()}>
      <div className={fieldContainer()}>
        {hasLabel ? (
          <label className={label()} id={`${props.name}-label`} htmlFor={props.fieldId}>
            {props.label}
          </label>
        ) : null}
        <div className={childrenContainer()}>{props.children}</div>
      </div>
      {assistiveTextOrError && <span className={assistiveText()}>{assistiveTextOrError}</span>}
    </div>
  )
}

export default TextFieldContainer
